<template>
  <div class="app-container" v-no-context>
    <Header />
    <Navbar />
    <div class="container">
      <Sidebar />
      <div class="content">
        <router-view />
      </div>
    </div>
    <Footer />
    <Modal v-if="modalVisible" :title="modalTitle" :content="modalContent" @close="closeModal" />
  </div>
</template>

<script>
import { ref, provide } from 'vue'
import Header from './components/Header.vue'
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar.vue'
import Footer from './components/Footer.vue'
import Modal from './components/Modal.vue'

export default {
  name: 'App',
  components: { Header, Navbar, Sidebar, Footer, Modal },
  setup() {
    const modalVisible = ref(false)
    const modalTitle = ref('')
    const modalContent = ref('')

    const showModal = (title, content) => {
      modalTitle.value = title
      modalContent.value = content
      modalVisible.value = true
    }

    const closeModal = () => {
      modalVisible.value = false
    }

    provide('showModal', showModal)

    return { modalVisible, modalTitle, modalContent, closeModal }
  }
}
</script>

<style lang="scss">
@import './assets/scss/variables';

/* 全局样式... */
:root {
  --primary-color: #8d6e63;  /* 棕 */
  --primary-light: #be9c91;  /* 浅棕 */
  --primary-dark: #5d4037;   /* 深棕 */
  --secondary-color: #6d4c41; /* 深棕 */
  --light-gray: #efebe9;     /* 浅米 */
  --medium-gray: #d7ccc8;    /* 米灰 */
  --dark-gray: #4e342e;      /* 深棕 */
  --white: #fff8f5;          /* 米白 */
  --box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  --border-radius: 8px;
  --transition: all 0.3s ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

body {
  background-color: var(--light-gray);
  color: var(--dark-gray);
  line-height: 1.6;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}

.container {
  width: min(1200px, 96%);
  margin: 25px auto;
  display: grid;
  grid-template-columns: minmax(200px, 250px) 1fr;
  gap: clamp(15px, 3vw, 30px);
  flex: 1;
}

.content {
  background-color: var(--white);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  padding: clamp(20px, 3vw, 30px);
}


@media (max-width: 768px) {
  .container {
    grid-template-columns: 1fr;
  }

  .content {
    order: 1;
  }
}
</style>